/*
 * Copyright (C) 2014 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './bulkRestoreInfo.tpl.html';

angular
  .module('batch.bulkrestore.info', ['ngSanitize', 'services.view'])
  /**
   * Controller for the bulkrestore.info template.
   */
  .controller(
    'BulkRestoreInfoCtrl',
    function (
      $scope,
      $filter,
      $state,
      $window,
      batchUtils,
      BulkRestoreService,
      UserAgentFactory,
      progressFactory,
      ALERT_EVENTS,
      lastState,
      BATCH_RESULTS,
      VIEW_STATES,
      viewUtils
    ) {
      let batchDate;

      /**
       * Utility function for returning to the previous state.
       */
      $scope.goBack = function () {
        viewUtils.resetState($state.current.name);
        $state.go(lastState || VIEW_STATES.LOG_HOME);
      };

      /**
       * Set the scope properties.
       */
      function updateInfo() {
        const jobType =
            $scope.batchUtils.currentBatch.type === 'CROSS_ORG_RESTORE'
              ? $filter('i18n')('CROSS_ORG_RESTORE')
              : $filter('i18n')('MULTI_RECORD_RESTORE'),
          objectsComplete =
            ($scope.batchUtils.currentBatch.bulkRestoreData &&
              $scope.batchUtils.currentBatch.bulkRestoreData.objectsComplete) ||
            0,
          totalObjects =
            ($scope.batchUtils.currentBatch.bulkRestoreData &&
              $scope.batchUtils.currentBatch.bulkRestoreData.totalObjects) ||
            0;
        $scope.numNonRestoredObjects = totalObjects - objectsComplete;
        const numErrors = $scope.batchUtils.currentBatch.errors;
        const percentComplete = totalObjects > 0 ? Math.ceil((objectsComplete / totalObjects) * 100) : 0,
          errorText = numErrors === 1 ? $filter('i18n')('ERROR') : $filter('i18n')('ERRORS');
        $scope.boinkCls =
          $scope.batchUtils.currentBatch.status && batchUtils.STATUS[$scope.batchUtils.currentBatch.status]
            ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].bigBoinkCls
            : '';

        batchDate = moment($scope.batchUtils.currentBatch.date);
        $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE_BULK_RESTORE', [
          batchDate.format(SBSF.messages.M_D_Y),
          batchDate.format(SBSF.messages.H_M),
          jobType,
          $filter('i18n')('OBJECTS_RESTORED', [objectsComplete, totalObjects])
        ]);

        $scope.pctCls = function () {
          return $scope.batchUtils.currentBatch.status
            ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].textCls
            : '';
        };

        $scope.userEmailStr = $filter('i18n')(
          'RESTORE_BY',
          $scope.batchUtils.currentBatch.bulkRestoreData && $scope.batchUtils.currentBatch.bulkRestoreData.userEmail
        );
        $scope.percentCompleteStr = $filter('i18n')('PERCENT_COMPLETE', [percentComplete, numErrors, errorText]);
      }

      // If a currentBatch is empty set redirect app to the admin view.
      if (_.isEmpty($scope.batchUtils.currentBatch)) {
        $scope.goBack();
      } else {
        updateInfo();
      }

      /**
       * Handler to queue message for bulk restore preview of failed items.
       */
      $scope.exportBulkRestoreFailedRecords = function () {
        var batchId = $scope.batchUtils.currentBatch.batchId;

        if ($scope.batchUtils.currentBatch.status !== BATCH_RESULTS.SUCCESS) {
          batchUtils.bulkRestoreFailedRecords(batchId).then(
            function () {
              progressFactory.bulkRestorePreviewInProgress = true;
            },
            function () {
              $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('SUBMIT_BULK_RESTORE_PREVIEW_FAILED'));
              progressFactory.bulkRestorePreviewInProgress = false;
            }
          );
        }
      };

      /**
       * Handler for the download of CSV file.
       */
      $scope.downloadCsv = function () {
        var batch = $scope.batchUtils.currentBatch;
        var batchId = batch.batchId;
        var s3Key = batch.bulkRestoreData.auditCsvKey;
        var s3location = batch.bulkRestoreData.auditCsvLocation;

        if (s3Key) {
          // If the S3 key is present get a signed URL pointing to the CSV file
          // For security reasons we're going to send the batch id and make the back end code
          // validate that the caller owns that batch get the S3 key again in the back end.
          BulkRestoreService.getPreSignedCsvDownloadUrl(batchId).then(function (url) {
            $window.location.href = url;
          });
        } else if (s3location) {
          // If the S3 key is not present try the pre-signed URL. Note that it expires after 7 days so this may not work.
          // TODO In order to catch an expired URL we'd have to make an http get request to it first.
          // TODO Even if we did catch it we'd need a way to remove the expired URL from the batch record and replace it
          // TODO with the original S3 key
          $window.location.href = s3location;
        } else {
          // The CSV file is not available in S3, so download it
          batchUtils.downloadBulkRestoreCsv(batchId).then(function (result) {
            var blob,
              browser = UserAgentFactory.detectBrowser();
            //If it's IE do some black magic and use custom IE specific methods (MsSaveBlob) to save this file.
            if (browser && browser.indexOf('IE') > -1) {
              if ($window.navigator.msSaveOrOpenBlob) {
                blob = new Blob([decodeURIComponent(encodeURI(result))], {
                  type: 'text/csv;charset=utf-8;'
                });
                navigator.msSaveBlob(blob, 'BulkRestore.csv');
              }
            } else {
              $window.location.href = 'data:text/csv;charset=utf8,' + encodeURI(result);
            }
          });
        }
      };

      /**
       * Handler for the control to show and hide the error/warning messages.
       */
      $scope.toggleMessages = function () {
        $scope.$parent.showMessages = !$scope.$parent.showMessages;
      };
    }
  );
